gsap.registerPlugin(ScrollTrigger);
gsap.utils.toArray('.image-container-parallax').forEach(function (container) {
  triggerParallax(container);
});

function triggerParallax(container) {
  var image = container.querySelector('img');
  
  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      scrub: true,
      pin: false,
    },
  });

  // Add scaling to ensure image covers the container while moving
  tl.fromTo(image, 
    {
      yPercent: -25,   // Start position with a reasonable negative value
    }, 
    {
      yPercent: 0,    // End position with a smaller positive value
      ease: 'none'
    }
  );
}